var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('div',[_c('center',[_c('h1',[_vm._v("404 Not Found")])]),_vm._v(" "),_c('hr'),_c('center',[_vm._v("nginx/1.4.1")])],1):_c('div',[_vm._v("\n    服务异常，请检查网址是否正确\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }